import React, { useState } from 'react';
import Sidebar from '../../components/ui/Sidebar';
import Header from '../../components/ui/Header';
import WelcomeHeader from './components/WelcomeHeader';
import QuickActions from './components/QuickActions';
import RecentLeaveHistory from './components/RecentLeaveHistory';
import UpcomingHolidays from './components/UpcomingHolidays';
import NotificationCenter from './components/NotificationCenter';
import SalaryInformation from './components/SalaryInformation';

const EmployeeDashboard = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);

  return (
    <div className="min-h-screen bg-background">
      <Sidebar 
        isCollapsed={sidebarCollapsed}
        onToggle={(collapsed) => setSidebarCollapsed(collapsed)} 
        isMobileOpen={mobileMenuOpen}
        onMobileClose={() => setMobileMenuOpen(false)}
      />
      <Header 
        sidebarCollapsed={sidebarCollapsed} 
        onMobileMenuToggle={() => setMobileMenuOpen(!mobileMenuOpen)}
      />
      
      <main className={`pt-16 transition-smooth ${sidebarCollapsed ? 'md:ml-16' : 'md:ml-240'} ml-0`}>
        <div className="p-4 md:p-6 max-w-7xl mx-auto">
          {/* Welcome Header */}
          <WelcomeHeader />
          
          {/* Quick Actions */}
          <QuickActions />
          
          {/* Notifications */}
          <NotificationCenter />
          
          {/* Main Content Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6 mb-6">
            {/* Left Column */}
            <div className="space-y-4 md:space-y-6">
              <RecentLeaveHistory />
              <SalaryInformation />
            </div>
            
            {/* Right Column */}
            <div className="space-y-4 md:space-y-6">
              <UpcomingHolidays />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default EmployeeDashboard;